import React from "react";
import { Layout } from "antd";

import PermutedBlocksForm from "./PermutedBlocksForm";
import isAuthenticated from "../../utils/isAuthenticated";
import { withNamespaces } from "react-i18next";

import classes from "./style.css";

const { Content } = Layout;

class PermutedBlocks extends React.Component {
  render() {
    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <PermutedBlocksForm />
          </Content>
        </Layout>
      </div>
    );
  }
}

export default isAuthenticated(withNamespaces()(PermutedBlocks));



// WEBPACK FOOTER //
// ./src/containers/PermutedBlocks/PermutedBlocks.js